export default __webpack_public_path__ + "station-defect-belt-gray.png?de0cf5d59a449dffa19fa86b5414cac6";